import { useNavigate } from "react-router-dom";
export function SidebarLogoLong() {
  const history = useNavigate();
  return (
    <img
      src={require("../../assets/horizontal-logo-english-1.png")}
      alt="logo"
      style={{ height: "40px" }}
      onClick={() => history("/")}
    />
  );
}
